import useAppStore from '@/stores/AppStore';
import React from 'react';
import { useShallow } from 'zustand/react/shallow';
export default function useColorModeValue(light, dark) {
    var colorMode = useAppStore(useShallow(function(state) {
        return {
            colorMode: state.colorMode
        };
    })).colorMode;
    return React.useMemo(function() {
        return colorMode === 'dark' ? dark : light;
    }, [
        light,
        dark,
        colorMode
    ]);
}
